import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import { commonRegex } from "../../../helpers/commonRegex";

export type Inputs = "curp";
export type Buttons = "buscar" | "aceptar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "curp",
      label: "CURP",
      bts: { mCol: 6 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        maxlength: 18
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    },
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: false,
      bts: { mCol: 3 }
    }
  ],
  validations: {
    curp: {
      requiredIfCurp: {
        validator: value => !value,
        message: () => "Campo obligatorio"
      },
      curpRegex: {
        validator: (value: string, formValue: any) =>
          value &&
          formValue.tipoBusqueda === "CURP" &&
          !formValue.paramCurp &&
          !commonRegex.curp.test(value.toUpperCase()),
        message: () => "La CURP ingresada no es válida"
      }
    }
  },
  rows: [["curp", "buscar", "aceptar"]]
};
